// Firebase Web SDK init for the S7 Email Builder. Exports a singleton
// `FirebaseStorage` via `getFirebaseStorage()`.
//
// **Config is embedded, not env-var.** Firebase Web SDK config (apiKey,
// authDomain, projectId, storageBucket, messagingSenderId, appId) is
// PUBLIC identifier data — security is enforced by Storage rules +
// Anonymous Auth (see `storage.rules`, spec/tech-arch.md §12.7), not by
// hiding the identifiers. Decision recorded in P-FS-02 D-119.
//
// **Static imports of this module are forbidden** — consumers must
// dynamic-import so Vite code-splits the SDK into a lazy chunk
// (initial-bundle accounting per OC §3.2 / build-plan §3.1).

import {
  initializeApp,
  getApp,
  getApps,
  type FirebaseApp,
  type FirebaseOptions,
} from 'firebase/app'
import { getAuth, type Auth } from 'firebase/auth'
import { getFirestore, type Firestore } from 'firebase/firestore'
import { getStorage, type FirebaseStorage } from 'firebase/storage'

const firebaseConfig: FirebaseOptions = {
  apiKey: 'AIzaSyAWZinPOi3dG8WN2VxLRolUNQ--O27w4iQ',
  authDomain: 'ypo-email-builder.firebaseapp.com',
  projectId: 'ypo-email-builder',
  storageBucket: 'ypo-email-builder.firebasestorage.app',
  messagingSenderId: '833864136044',
  appId: '1:833864136044:web:6e35c5abdec347804aaf49',
}

let cachedStorage: FirebaseStorage | null = null
let cachedAuth: Auth | null = null
let cachedFirestore: Firestore | null = null

function getFirebaseApp(): FirebaseApp {
  return getApps().length > 0 ? getApp() : initializeApp(firebaseConfig)
}

export function getFirebaseStorage(): FirebaseStorage {
  if (cachedStorage) return cachedStorage
  cachedStorage = getStorage(getFirebaseApp())
  return cachedStorage
}

export function getFirebaseAuth(): Auth {
  if (cachedAuth) return cachedAuth
  cachedAuth = getAuth(getFirebaseApp())
  return cachedAuth
}

export function getFirebaseFirestore(): Firestore {
  if (cachedFirestore) return cachedFirestore
  cachedFirestore = getFirestore(getFirebaseApp())
  return cachedFirestore
}
